import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ToolkitIntro } from './components/ToolkitIntro';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Tools } from './components/Tools';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { ReturnTo } from './components/ReturnTo';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="23vkzcrxgytqi">
      <MetaPixel data-id="element-1" data-mp="23ti6m04xmmi3" />
      <Hero data-id="element-2" data-mp="3ik7ekc2063oj" />
      <main data-id="element-3" data-mp="3ikqzm1my986s">
        <ToolkitIntro data-id="element-4" data-mp="3iiwfuqnezm4a" />
        <BeforeAfter data-id="element-5" data-mp="3ijpbavgxap74" />
        <PainPoints data-id="element-6" data-mp="3ii4r9zs8ioni" />
        <Volumes data-id="element-7" data-mp="3mlat8v8bdto6" />
        <Tools data-id="element-8" data-mp="3mkrgdsxitvh0" />
        <Bonuses data-id="element-9" data-mp="3mk84asujy1aw" />
        <Offer data-id="element-10" data-mp="3mjq3rk0ux0x6" />
        <ReturnTo data-id="element-11" data-mp="3mj6jvxrnc2gi" />
        <Testimonials data-id="element-12" data-mp="3rcj7c4kla37o" />
        <Author data-id="element-13" data-mp="3rdaqgfx028h2" />
        <Faq data-id="element-14" data-mp="3rdkkqfp2v1sk" />
        <FinalCta data-id="element-15" data-mp="3rd19fhtxnbni" />
      </main>
      <Footer data-id="element-16" data-mp="5yh2n2cyzbp" />
      <PurchasePopup data-id="element-17" data-mp="6hovayao7c0" />
      <FloatingCta data-id="element-18" data-mp="4wylxj0jajy" />
    </div>;
}